import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  getFlightsResponseBody,
  isResponseContainFlightsBody,
  isFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import type {
  MutationResponseAction,
  QueryResponseAction,
  Action,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  Alliance,
  AllianceState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/alliances';

export const INITIAL_STATE: AllianceState = {
  byId: {},
};

const byId = (
  state: Record<number, Alliance>,
  action: MutationResponseAction | QueryResponseAction,
) => {
  switch (action.payload.type) {
    case RADAR_CREATE_SESSIONS:
    case RADAR_POLL: {
      if (
        isFlightsResponseError(action.payload.response) ||
        !isResponseContainFlightsBody(action.payload.response)
      ) {
        return state;
      }

      const flightsResponseBody = getFlightsResponseBody(action.payload.response);
      const alliances = flightsResponseBody.alliances || [];
      return { ...state, ...keyBy(alliances, (alliance) => alliance.id) };
    }

    default:
      return state;
  }
};

const alliancesReducer = (state: AllianceState = INITIAL_STATE, action: Action): AllianceState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export default alliancesReducer;

export type { Alliance, AllianceState };
